import { defineStore } from 'pinia';
import CustomPayment from '~~/constants/customPayment';
import type { PaymentSelectedState } from '~~/types/vuex/PaymentSelected';

export const paymentSelectedStore = defineStore('paymentSelected', {
  state: () => ({ paymentSelected: CustomPayment.ADYEN as PaymentSelectedState['paymentSelected'] | null }),
  actions: {
    setPaymentSelected(payload: PaymentSelectedState['paymentSelected'] | null) {

      this.paymentSelected = payload; 

    },
  },
});
